import type { ScreenParameters, SpecificNavigationProp } from 'app/types/navigation';
import type { Channel, TextMessageMessage } from 'app/types/chat';
import { isMobileNative } from 'app/utils/web-helpers';

const routeNameSetCache = new WeakMap<readonly string[], ReadonlySet<string>>();

function getRouteNameSet(routeNames: readonly string[]) {
  const cachedRouteNames = routeNameSetCache.get(routeNames);
  if (cachedRouteNames) return cachedRouteNames;

  const routeNameSet = new Set(routeNames);
  routeNameSetCache.set(routeNames, routeNameSet);
  return routeNameSet;
}

export function navigateToChat<T extends keyof ScreenParameters>(
  navigation: SpecificNavigationProp<T>,
  url: Channel['channel_url'],
  messagePrompt?: TextMessageMessage,
  toast?: string,
) {
  if (!url) return;
  if (!isMobileNative) {
    let parent = navigation.getParent();
    while (parent && !getRouteNameSet(parent.getState().routeNames).has('chat')) {
      parent = parent.getParent();
    }

    if (parent) {
      parent.navigate(
        'chat',
        {
          screen: 'one-channel',
          params: { url, messagePrompt, toast },
        },
        { pop: true },
      );
      return;
    }

    navigation.navigate(
      'chat',
      {
        screen: 'one-channel',
        params: { url, messagePrompt, toast },
      },
      { pop: true },
    );
    return;
  }

  if (navigation.getState().routeNames.includes('one-channel')) {
    navigation.navigate('one-channel', { url, messagePrompt, toast }, { pop: true });
  } else {
    navigation.navigate(
      'chat',
      {
        screen: 'one-channel',
        params: { url, messagePrompt, toast },
        initial: false,
      },
      { pop: true },
    );
  }
}
